// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1fS0n","select":"Header_select__3lizi","clinic":"Header_clinic__3Wx7W"};